import request from "@/api/http";

const processAPI = {
  deleteProcessComment(params, callback) {
    return request.post(
      process.env.BASE_URL + `/lvjing/flow/comment/` + params.commentId,
      { method: "DELETE" },
      callback,
    );
  },
  postProcessComment(params, callback) {
    return request.post(
      process.env.BASE_URL + `/lvjing/flow/comment/publish`,
      params,
      callback,
    );
  },
  getProcessComment(params, callback) {
    return request.get(
      process.env.BASE_URL + `/lvjing/flow/comment/list/` + params.processId,
      {},
      callback,
    );
  },
  restartProcess(params, callback) {
    return request.post(
      process.env.BASE_URL + `/lvjing/flow/process/restart`,
      params,
      callback,
    );
  },
  cancelProcess(params, callback) {
    return request.post(
      process.env.BASE_URL + `/lvjing/flow/process/cancel`,
      params,
      callback,
    );
  },
  addCustomProcess(params, callback) {
    return request.post(
      process.env.BASE_URL + `/lvjing/flow/process/start`,
      params,
      callback,
    );
  },
  //获取自定义流程列表
  getCustomProcessList(params, callback) {
    return request.get(
      process.env.BASE_URL + `/lvjing/flow/model/find`,
      params,
      callback,
    );
  },
  // 项目进场申请
  addProjectApproachApply(params, callback) {
    return request.post(
      process.env.BASE_URL + `/project/addProjectApproachApply`,
      params,
      callback,
    );
  },
  // 项目退场
  addProjectQuitApply(params, callback) {
    return request.post(
      process.env.BASE_URL + "/project/addProjectQuitApply",
      params,
      callback,
    );
  },
  // 项目转区域添加
  addProjectAreaChange(params, callback) {
    return request.post(
      process.env.BASE_URL + "/project/addProjectAreaChange",
      params,
      callback,
    );
  },
  // （新增/续签）合同流程
  addProjectContractNews(params, callback) {
    return request.post(
      process.env.BASE_URL + "/project/addProjectContractNews",
      params,
      callback,
    );
  },
  // 新增合同补充协议流程
  addProjectContractAgreement(params, callback) {
    return request.post(
      process.env.BASE_URL + "/project/addProjectContractAgreement",
      params,
      callback,
    );
  },
  // 文件处理流程
  addCustomProcessOld(params, callback) {
    return request.post(
      process.env.BASE_URL + "/project/addCustomProcess",
      params,
      callback,
    );
  },
  // 用印申请流程
  addSealProcess(params, callback) {
    return request.post(
      process.env.BASE_URL + "/project/addSealProcess",
      params,
      callback,
    );
  },
  // 流程审核 （拒绝/通过）老
  workProcessAudit(params, callback) {
    return request.post(
      process.env.BASE_URL + "/project/workProcessAudit",
      params,
      callback,
    );
  },
  // 流程审核 （通过）新
  workProcessResolve(params, callback) {
    return request.post(
      process.env.BASE_URL + "/lvjing/flow/task/complete",
      params,
      callback,
    );
  },
  // 流程审核 （拒绝）新
  workProcessReject(params, callback) {
    return request.post(
      process.env.BASE_URL + "/lvjing/flow/task/reject",
      params,
      callback,
    );
  },
  // 流程审核 （会审）新
  workProcessMeetingNew(params, callback) {
    return request.post(
      process.env.BASE_URL + "/lvjing/flow/task/meeting",
      params,
      callback,
    );
  },
  // 流程审核 （会审）老
  workProcessMeeting(params, callback) {
    return request.post(
      process.env.BASE_URL + "/project/workProcessMeeting",
      params,
      callback,
    );
  },
  // 流程审核 （移交他人）新
  workProcessChangeNew(params, callback) {
    return request.post(
      process.env.BASE_URL + `/lvjing/flow/task/workProcessChange`,
      params,
      callback,
    );
  },
  // 流程审核 （移交他人）老
  workProcessChange(params, callback) {
    return request.post(
      process.env.BASE_URL + "/project/workProcessChange",
      params,
      callback,
    );
  },
  // 获取收款人列表（报销）
  getPayeeList(params, callback) {
    return request.post(
      process.env.BASE_URL + "/materials/getPayeeList",
      params,
      callback,
    );
  },
  //添加现金报销申请
  addCashReimbursement(params, callback) {
    return request.post(
      process.env.BASE_URL + "/project/addCashReimbursement",
      params,
      callback,
    );
  },
  //添加借款申请
  addBorrowMoney(params, callback) {
    return request.post(
      process.env.BASE_URL + "/project/addBorrowMoney",
      params,
      callback,
    );
  },
  //费用支付申请
  addCostPay(params, callback) {
    return request.post(
      process.env.BASE_URL + "/project/addCostPay",
      params,
      callback,
    );
  },
  //差旅费报销申请
  addTravelReimbursement(params, callback) {
    return request.post(
      process.env.BASE_URL + "/project/addTravelReimbursement",
      params,
      callback,
    );
  },
  //获取流程关联财务类型
  getReimbursementType(params, callback) {
    return request.get(
      process.env.BASE_URL +
        `/materials/process/reimbursementType/` +
        params.modelId,
      {},
      callback,
    );
  },
  //获取流程关联财务类型及物耗关联物耗科目类型
  getProcessAndMaterialsReimbursementType(params, callback) {
    return request.get(
      process.env.BASE_URL +
        `/materials/reimbursementType/scene/` +
        params.sceneCode,
      {},
      callback,
    );
  },
  // 查询费用申请链路审核节点
  getApprovalNodes(applicationId, callback) {
    return request.get(
      process.env.BASE_URL +
        `/lvJingAPI/expense/applications/${applicationId}/flow-comments`,
      {},
      callback,
    );
  },
  // 查询费用申请统一详情（根据 applicationId 返回事前申请+正式报销完整信息）
  getExpenseApplicationDetail(params, callback) {
    return request.get(
      process.env.BASE_URL +
        `/lvJingAPI/expense/applications/${params.applicationId}/detail`,
      { businessType: params.businessType },
      callback,
    );
  },
  getPreApplyDetail(id, callback) {
    return request.get(
      process.env.BASE_URL + `/lvJingAPI/expense/pre-applications/${id}`,
      {},
      callback,
    );
  },
  // 查询费用预算映射列表
  getFeeCategoryBudgetMapList(query, callback) {
    return request.get(
      process.env.BASE_URL + "/lvJingAPI/expense/config/budget-mappings",
      query,
      callback,
    );
  },
  // 查询预算解析列表
  getBudgetResolutions(params, callback) {
    return request.post(
      process.env.BASE_URL + "/lvJingAPI/expense/budget/resolutions",
      params,
      callback,
    );
  },
  // 查询预算可用额度
  getBudgetAvailableAmount(params, callback) {
    return request.post(
      process.env.BASE_URL + "/lvJingAPI/expense/budget/usable-amounts",
      params,
      callback,
    );
  },
  // 查询单据财务类型关联配置
  getBillFinanceRelations(query, callback) {
    return request.get(
      process.env.BASE_URL + "/lvJingAPI/expense/config/bill-finance-relations",
      query,
      callback,
    );
  },
  // 打印验证：根据 printToken 查询报销单打印数据
  getPrintVerifications(params, callback) {
    return request.get(
      process.env.BASE_URL + "/lvJingAPI/expense/print-verifications",
      params,
      callback,
    );
  },
};

export default processAPI;
